import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function CTABanner() {
  return <section className="relative py-32 flex items-center justify-center overflow-hidden" data-id="element-26">
      {/* Parallax Background */}
      <div className="absolute inset-0 bg-fixed bg-cover bg-center z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")'
    }} data-id="element-27" />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-charcoal/70 z-10" data-id="element-28" />

      <div className="container mx-auto px-6 relative z-20 text-center" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-30">
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white uppercase tracking-wide mb-6" data-id="element-31">
            Ready to Make Your Move?
          </h2>
          <p className="font-body text-lg md:text-xl text-white/90 mb-10 font-light" data-id="element-32">
            Whether buying, selling, or investing — let's talk about your goals.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-33">
            <Button className="w-full sm:w-auto bg-gold hover:bg-gold-dark text-charcoal font-semibold rounded-none px-8 h-14 text-base" data-id="element-34">
              Schedule a Consultation
            </Button>
            <Button variant="outline" className="w-full sm:w-auto border-white text-white hover:bg-white hover:text-charcoal rounded-none px-8 h-14 text-base bg-transparent" data-id="element-35">
              Call Nathan
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}